import { selectSelectedQueryTool, setSelectedQueryTool } from "../dataWranglerSlice";
import LassoToggleButtons from "../../../components/LassoToggleButtons";
import { useDispatch, useSelector } from "react-redux";
import FilterParticipantsButton from "./ParticipantFilter/FilterParticipantsButton";
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { boxShadows } from '../../../StyleConstants';
import useLocalStorage from '../../../hooks/useLocalStorage';

const ToolSelector = () => {
    const selectedQueryTool = useSelector(selectSelectedQueryTool);
    const dispatch = useDispatch();
    const [queryWizardTooltipSeen, setQueryWizardTooltipSeen] = useLocalStorage("queryWizardTooltipSeen", false);

    return (
        <Stack direction="row" gap={2} alignItems="center">
            <FilterParticipantsButton />
            <Box>
                <LassoToggleButtons
                    id="query-wizard-toggle-tool-buttons"
                    color="primary"
                    value={selectedQueryTool}
                    onChange={(e, newValue) => {
                        if (newValue) {
                            dispatch(setSelectedQueryTool(newValue))
                        }
                    }}
                    exclusive
                    buttons={[
                        {
                            label: "All Study Data",
                            value: "allStudyData",
                        },
                        {
                            label: "Query Wizard",
                            value: "queryWizard",
                        },
                        {
                            label: "Dictionary Query Tool",
                            value: "dictionary",
                        },
                    ]} />
                {!queryWizardTooltipSeen &&
                <Paper
                    sx={{ padding: 3,
                        marginTop: 3,
                        marginRight: 2,
                        boxShadow: boxShadows.levelFive,
                        position: "absolute",
                        right: "12px",
                        zIndex: 5,
                        "&::before": {
                            content: `""`,
                            position: "absolute",
                            top: "-16px",
                            left: "calc(50% + 32px)",
                            width: 0,
                            height: 0,
                            borderLeft: "24px solid transparent",
                            borderRight: "24px solid transparent",
                            borderBottom: "24px solid white",
                        }
                    }}
                >
                    <Stack width={"500px"} gap={3}>
                        <Typography
                            fontWeight={"bold"}
                            fontSize={"18px"}
                            fontFamily={"Roboto"}
                        >
                                Search, Filter, and Export with Ease
                        </Typography>
                        <Typography fontFamily={"Roboto"}>
                                Use Lasso’s Query Wizard and Dictionary Tool to quickly filter and search your study’s tabulated data.
                                See what measures were administered at each visit, then export results in one click as a .csv.
                        </Typography>
                        <Typography fontFamily={"Roboto"} fontWeight={"bold"}>
                                Support for formats like R, Parquet, and Arrow is coming soon!
                        </Typography>
                        <Button
                            variant={"primary"}
                            sx={{ alignSelf: 'flex-end' }}
                            size={"small"}
                            onClick={() => setQueryWizardTooltipSeen(true)}
                        >
                          Got it!
                        </Button>
                    </Stack>
                </Paper>
                }
            </Box>

        </Stack>
    )
}

export default ToolSelector;